import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSketch32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconSketch32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="m16.052 6.003 6.04.71a.46.46 0 0 1 .32.192l4.497 6.314c.128.18.12.43-.02.6L16.176 26.915a.225.225 0 0 1-.352 0L5.11 13.82a.5.5 0 0 1-.02-.6l4.497-6.314a.46.46 0 0 1 .32-.192l6.04-.71a.5.5 0 0 1 .104 0m1.254 1.362a.095.095 0 0 0-.131-.007.105.105 0 0 0-.024.131l.009.012 3.406 4.42a.25.25 0 0 1 .051.15c0 .127-.093.23-.212.24l-.02.002h-8.77a.23.23 0 0 1-.146-.053.25.25 0 0 1-.048-.322l.013-.018 3.406-4.419a.105.105 0 0 0-.007-.136.095.095 0 0 0-.128-.01l-.01.01-4.616 4.836a.18.18 0 0 1-.14.056.19.19 0 0 1-.176-.183v-.019l.16-3.502a.096.096 0 0 0-.073-.099.09.09 0 0 0-.107.06l-.004.013-.874 4.031a.38.38 0 0 1-.259.286l-.024.006-2.165.486a.096.096 0 0 0-.073.095c0 .049.035.089.08.095l.012.001h2.16c.126 0 .242.067.31.175l.013.023 5.18 9.63a.136.136 0 0 0 .181.06.15.15 0 0 0 .072-.177l-.005-.015-4.189-9.283a.3.3 0 0 1-.026-.123c0-.153.114-.278.258-.289h11.2q.063 0 .119.027a.294.294 0 0 1 .14.366l-.007.019-4.189 9.283a.15.15 0 0 0 .058.188c.063.036.14.017.181-.042l.008-.014 5.181-9.63a.37.37 0 0 1 .298-.197h2.185a.094.094 0 0 0 .09-.077.1.1 0 0 0-.059-.11l-.012-.005-2.165-.486a.38.38 0 0 1-.277-.266l-.006-.026-.875-4.03a.09.09 0 0 0-.094-.076.094.094 0 0 0-.088.088v.013l.159 3.502a.2.2 0 0 1-.054.146.18.18 0 0 1-.248.013l-.014-.014z"
            />
        </svg>
    );
}
export default memo(IconSketch32);
